import { useEffect, useRef } from "react";

const useSkipFirstRender = () => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  return isFirstRender.current;
};

export default useSkipFirstRender;
